export enum CALL_ACCESS_LOG_TABLE_COLUMNS {
   BUTTON = 'Button',
   UNIT = 'Unit',
   CALL_STATE = 'CallState',
   DATE = 'Date'
}

export const CALL_ACCESS_LOG_DEFAULT_SORT_COLUMN = CALL_ACCESS_LOG_TABLE_COLUMNS.DATE;
export const CALL_ACCESS_LOG_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const CALL_ACCESS_LOG_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const CALL_ACCESS_LOG_PAGE_DEFAULT_SIZE = 20;

export const CALL_ACCESS_LOG_TABLE_HEADER = [
   CALL_ACCESS_LOG_TABLE_COLUMNS.BUTTON,
   CALL_ACCESS_LOG_TABLE_COLUMNS.UNIT,
   CALL_ACCESS_LOG_TABLE_COLUMNS.CALL_STATE,
   CALL_ACCESS_LOG_TABLE_COLUMNS.DATE,
];